import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgeAdminSettingsRoute: InvariantJiraRoute = {
	name: 'forge-spa-admin-settings',
	path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?',
};
